export default __webpack_public_path__ + "static/media/main box2.12413cf1.png";